<div class="fluid-container">
    <div class="row pt-4 d-flex align-items-center">
        <div class="col-md-11 step-title p-0">
            <h5 class="mb-0">Send Notification</h5>
        </div>
        <div class="col-md-1 pr-0 d-flex justify-content-end">
            <i (click)="handleClose();" class="close-icon pi pi-times"></i>
        </div>
    </div>
    <p-divider></p-divider>
    <form class="pb-3 pt-2" (ngSubmit)="postSendNotification()" #sendNotificationForm="ngForm">
        <div class="row mb-3">
            <div class="col-md-4 form-group processing-dropdown">
                <label class="label-cls required">To</label>

                <p-dropdown [options]="receiversList" [filter]="false" name="selectedReceiverType"
                    [(ngModel)]="notification.selectedReceiverType" optionLabel="name" [disabled]="disabledControls"
                    placeholder="Select Receiver" required>
                </p-dropdown>
                <div
                    *ngIf="sendNotificationForm.controls['selectedReceiverType'].touched && sendNotificationForm.controls['selectedReceiverType'].invalid">
                    <span class="invalid-message"
                        *ngIf="sendNotificationForm.controls['selectedReceiverType'].errors?.required">
                        {{getGlobalErrorMessages('REQUIRED')}}
                    </span>
                </div>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-12 form-group">
                <textarea type="text" class="im-input mw-100" name="message" #message="ngModel"
                    [readOnly]="disabledControls" placeholder="Type Message" [(ngModel)]="notification.message"
                    pInputTextarea></textarea>
                <div
                    *ngIf="sendNotificationForm.controls['message'].touched && sendNotificationForm.controls['message'].invalid">
                    <span class="invalid-message" *ngIf="sendNotificationForm.controls['message'].errors?.required">
                        {{getGlobalErrorMessages('REQUIRED')}}
                    </span>
                </div>
            </div>
        </div>
        <p-divider></p-divider>
        <div class="row pt-3">
            <div class="col-md-8"> </div>
            <div class="col-md-2 pull-right">
                <button pButton type="submit" label="Send" icon="pi pi-save"
                    [ngClass]="sendNotificationForm.invalid  || disabledControls ? 'btn-success button-width-icon-left mr-3 btn-success_disabled':'btn-success button-width-icon-left mr-3'"
                    [disabled]="sendNotificationForm.invalid  || disabledControls"></button>
            </div>
            <div class="col-md-2">
                <button pButton type="button" label="Cancel"  icon="pi pi-times-circle"
                class="p-button-secondary cancel-btn button-width-icon-left 
                d-flex alogn-items-center" [disabled]="disabledControls" (click)="handleCancel()">
                </button>
            </div>
        </div>
    </form>
</div>